import * as React from "react";
import styled from "styled-components";
import { CouponItemProps } from "..";
import { CouponBtn } from "./CouponBtn";
import { px2rem } from "../../../../utils/css";

/** 宽高固定，自动截取 */
const DoubleWrapper = styled.div`
	display: grid;
	gap: ${px2rem(9)};
	grid-template-columns: repeat(2, ${px2rem(171)}); // 设计稿171px
	img {
		width: 100%;
		height: ${px2rem(84)};
		object-fit: cover;
	}
`;

export const Double = (props: CouponItemProps) => {
	const { coupons = [], ...others } = props;
	return (
		<DoubleWrapper>
			{coupons.map((ele) => {
				return <CouponBtn key={ele.img} coupon={ele} {...others} />;
			})}
		</DoubleWrapper>
	);
};
